
export const initializeDelighted = (user, account) => {
  if (typeof window.delighted === 'undefined') {
    console.warn('Delighted NPS não foi carregado.');
    return;
  }

  if (!user || !user.email) {
    console.warn('Dados do usuário não disponíveis para Delighted NPS.');
    return;
  }

  try {
    const currentAccountData = user.accounts?.find(
      acc => acc.id === account?.id
    );
    const userRole = currentAccountData?.role || 'unknown';

    window.delighted.survey({
      email: user.email,
      name: user.name,
      createdAt: user.created_at,
      properties: {
        account_id: account?.id,
        company: account?.name || 'N/A',
        user_role: userRole,
      },
    });
  } catch (error) {
    console.error('Erro ao inicializar Delighted NPS:', error);
  }
};

export const resetDelighted = () => {
  if (typeof window.delighted !== 'undefined' && window.delighted.reset) {
    window.delighted.reset();
  }
};
